/** Margin as a whole percentage of the rate. An asset with no rate has no margin to show. */
export const marginPercent = (rate: number, hardCost: number) =>
  rate > 0 ? `${Math.round(((rate - hardCost) / rate) * 100)}%` : '-';
